<template>
  <base-toast :classes="actionMessage.class" :text="actionMessage.text"></base-toast>
  <div class="table-responsive">
    <table v-if="orders.length > 0" class="table table-striped table-hover">
      <thead>
        <tr>
          <th class="col">Nummer</th>
          <th class="col">Name der Karte</th>
          <th class="col">Bestelldatum</th>
          <th class="col">Lieferdatum</th>
          <th class="col">Status</th>
          <th class="col">Sendungsverfolgung</th>
          <th class="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, index) in orders" :key="index">
          <td>
            <a :href="'/orders/' + order.id">{{ order.attributes.number }}</a>
          </td>
          <td class="text-break">{{ order.relationships.menus.attributes.name }}</td>
          <td>
            {{ order.attributes.created_at }}
          </td>
          <td>
            {{
              order.attributes.status == 'REJECTED' || order.attributes.status == 'CANCELED'
                ? 'entfällt'
                : order.attributes.delivery_date
            }}
          </td>
          <td class="text-nowrap">
            <i class="bi bi-circle-fill" :class="coloredStatus(order.attributes.status)"></i>
            {{ trans(`statuses.${order.attributes.status}`) }}
          </td>
          <td>
            <a v-if="order.attributes.tracking_url" :href="order.attributes.tracking_url" target="_blank">
              <i class="bi bi-box-arrow-up-right"></i>
              öffnen
            </a>
            <span v-else>unbekannt</span>
          </td>
          <td>
            <div class="dropdown dropend">
              <button
                class="btn border bg-white text-muted hover:text-secondary"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-three-dots"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end dropdown-menu-lg-start shadow">
                <a class="dropdown-item" :href="'/orders/' + order.id + (back ? '?back=' + back : '')"
                  ><i class="bi bi-eye-fill"></i> anzeigen
                </a>
                <a class="dropdown-item" :href="'/orders/' + order.id + '/rebuild'"
                  ><i class="bi bi-cart-plus-fill"></i> nachbestellen
                </a>
                <a class="dropdown-item" @click="copyMenu(order.attributes.menu_id)">
                  <base-icon-copy id="copy-icon"></base-icon-copy> kopieren
                </a>
                <a
                  v-if="order.attributes.status === 'RECEIVED'"
                  class="dropdown-item cursor-pointer"
                  target="_blank"
                  @click="cancelOrder(order.id)"
                  ><i class="bi bi-x-circle"></i> stornieren
                </a>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="text-center">
      <div role="alert" class="alert mb-0 alert-dark">
        Sie haben noch keine Aufträge. Klicken Sie
        <a href="/configuration">hier</a>
        um eine neue Karte zu erstellen.
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';

import useOrders from '@/composables/useOrders';
import useMenus from '@/composables/useMenus';

export default {
  props: {
    back: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { actionMessage, orders, fetchOrders, cancelOrder } = useOrders();
    const { copyMenu } = useMenus();

    onMounted(() => {
      fetchOrders();
    });

    const coloredStatus = (status) => {
      let styleClass = 'text-black';
      switch (status) {
        case 'RECEIVED':
          styleClass = 'text-warning';
          break;
        case 'WAITING_FOR_PAYMENT':
          styleClass = 'text-warning';
          break;
        case 'REJECTED':
          styleClass = 'text-primary';
          break;
        case 'CANCELED':
          styleClass = 'text-danger';
          break;
        case 'IN_PRODUCTION':
          styleClass = 'text-green';
          break;
        case 'SHIPPED':
          styleClass = 'text-success';
          break;
        case 'DELIVERED':
          styleClass = 'text-info';
          break;
      }
      return styleClass;
    };

    return {
      actionMessage,
      cancelOrder,
      coloredStatus,
      orders,
      fetchOrders,
      copyMenu,
    };
  },
};
</script>

<style lang="scss" scoped>
#copy-icon {
  width: 24px;
  height: auto;
}
</style>
